import {QueryBaseTypeWithWhere} from 'api/common';

export enum MediaFileObjectTypeEnum {
    ITEM_DATA = 'ITEM_DATA',
}

export interface MediaFileModel {
    id: string;
    userId: string;
    title: string;
    description: string;
    uniqueId?: string;
    objectId?: string;
    objectType?: string;
    fileName: string;
    partialFilePath: string;
    fullUrl?: string;
    status: MediaStatus;
    sizeInKbs: number;
    fileExtension: string;
    fileGuidName: string;
}

export enum MediaStatus {
    None = 'NONE',
    Deleted = 'DELETED',
    Uploaded = 'UPLOADED',
    Processing = 'PROCESSING',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
}
export enum MediaObjectType {
    itemData = 'ITEM_DATA',
}

export interface MediaFileCreateRequestModel {
    objectId: string;
    objectType: string;
    files: File[];
}
interface MediaFileFilters {
    objectId: string;
    objectType: string;
}
export interface GetAllMediaFilesRequest extends QueryBaseTypeWithWhere<MediaFileFilters> {}
